export default "__VITE_ASSET__43f0a9b2__"